<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M2.04102 13.5206V7.78081C2.04102 6.25852 2.64574 4.79858 3.72216 3.72216C4.79858 2.64574 6.25852 2.04102 7.78081 2.04102H13.5206" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.04102 36.4795V42.2193C2.04102 43.7416 2.64574 45.2015 3.72216 46.2779C4.79858 47.3544 6.25852 47.9591 7.78081 47.9591H13.5206" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M36.48 2.04102H42.2198C43.7421 2.04102 45.202 2.64574 46.2784 3.72216C47.3548 4.79858 47.9596 6.25852 47.9596 7.78081V13.5206" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M36.48 47.9591H42.2198C43.7421 47.9591 45.202 47.3544 46.2784 46.2779C47.3548 45.2015 47.9596 43.7416 47.9596 42.2193V36.4795" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.3906 19.2607H16.4181" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M33.6099 19.2607H33.6374" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.8257 33.7531C18.7609 32.7986 19.8772 32.0403 21.1092 31.5226C22.3412 31.0049 23.6641 30.7383 25.0004 30.7383C26.3368 30.7383 27.6597 31.0049 28.8916 31.5226C30.1236 32.0403 31.2399 32.7986 32.1752 33.7531" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: "SuccessIcon",
};
</script>
